import type { EntryFeeTier } from '@/types/services/mandate/mandate.type.ts';

export const MAX_ENTRY_FEE_TIERS = 10

export function isEntryFeeTierValid(tier: EntryFeeTier): boolean {
  const amount = Number(tier.amount)
  const rate = Number(tier.feeRate)
  return tier.amount !== null && tier.feeRate !== null &&
    Number.isFinite(amount) && amount > 0 &&
    Number.isFinite(rate) && rate >= 0 && rate <= 100
}

// Indexes of tiers sharing the same operator and amount with another tier (rejected by the API).
export function getDuplicateEntryFeeTierIndexes(tiers: EntryFeeTier[] | undefined): Set<number> {
  const duplicates = new Set<number>()
  const seen = new Map<string, number>()

  ;(tiers ?? []).forEach((tier, index) => {
    if (tier.amount === null || tier.amount === undefined || Number.isNaN(Number(tier.amount))) return
    const key = `${tier.operator}|${Number(tier.amount)}`
    const first = seen.get(key)
    if (first === undefined) {
      seen.set(key, index)
    } else {
      duplicates.add(first)
      duplicates.add(index)
    }
  })

  return duplicates
}

export function areEntryFeeTiersValid(tiers: EntryFeeTier[] | undefined): boolean {
  if (!tiers) return true
  return tiers.length <= MAX_ENTRY_FEE_TIERS &&
    tiers.every(isEntryFeeTierValid) &&
    getDuplicateEntryFeeTierIndexes(tiers).size === 0
}

// Request payload: the full list, numbers only (an empty list removes every existing tier).
export function toEntryFeeTiersPayload(tiers: EntryFeeTier[] | undefined): EntryFeeTier[] {
  return (tiers ?? []).map(tier => ({
    operator: tier.operator,
    amount: Number(tier.amount),
    feeRate: Number(tier.feeRate)
  }))
}
